import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {UntypedFormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {AdministrationInformationRestService} from '../../services/nso-data-portal/rest-services/administration-information-rest.service';

@Component({
  selector: 'wsd-select-age-group-type',
  templateUrl: './select-age-group-type.component.html',
  styleUrls: ['./select-age-group-type.component.css']
})
export class SelectAgeGroupTypeComponent implements OnInit, OnDestroy {


  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.LABEL';

  @Input()
  controlName: string = 'groupType';

  @Input()
  showPlaceholder: boolean = false;

  @Input()
  showLabel: boolean = false;

  @Output()
  onChange = new EventEmitter<any>();

  groupTypes: SelectItem[] = [];

  private serviceSubscription: Subscription;

  constructor(private administrationRestService: AdministrationInformationRestService) {
  }

  ngOnInit() {
    this.initValues();
  }

  ngOnDestroy() {
    this.serviceSubscription.unsubscribe();
  }

  private initValues() {
    this.groupTypes = [];
    this.serviceSubscription = this.administrationRestService.getAgeGroupsTypes().subscribe(
      (data: string[]) => {
        for (const item of data) {
          this.groupTypes.push({
            label: item,
            value: item
          });
          if (this.parentForm.get(this.controlName) &&
            this.parentForm.get(this.controlName).value &&
            this.parentForm.get(this.controlName).value === item) {
            this.parentForm.get(this.controlName).setValue(item);
          }
        }
      }
    );
  }

  changeDropdownValue() {
    this.onChange.emit();
  }
}
